import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getScimAudit = api(async function getScimAudit({ clientId, skip = 0, take = 50, operation } = {}) {
    return await query(
        gql`
            query getScimAudit($clientId: String, $skip: Int, $take: Int, $operation: String) {
                getScimAudit(clientId: $clientId, skip: $skip, take: $take, operation: $operation) {
                    _id
                    createdAt
                    actor
                    operation
                    resourceType
                    resourceId
                    externalId
                    outcome
                    detail
                    # SNAG-049: the expansion panel renders Before/After (activity-row.js) and the
                    # server has always exposed them as JSON on ScimAuditEntry, but they were never
                    # selected here — so entry.before/entry.after were always undefined and the panel
                    # silently rendered the Actor alone, despite the section promising "the full actor
                    # + before/after state". That also made SNAG-046's rename fix invisible: the audit
                    # recorded the pre-write identity correctly and no one could see it.
                    before
                    after
                }
            }
        `,
        { clientId, skip, take, operation },
        { returns: "getScimAudit", fetchPolicy: "network-only" }
    )
})
